import * as React from 'react';
import { Grid } from '@material-ui/core';
import { withStyles, StyledComponentProps } from '@material-ui/core/styles';
import { styles } from '../../styles';
import { reservationRoom, reservationSlot } from '../../../../model/reservation';
import ReservationColumnDayHeader from './ReservationColumnDayHeader';
import ReservationSlot from './ReservationSlot';
import moment from 'moment';
import { getReservationMinStartDate, getReservationMaxEndtDate, getMinutesOfDay } from './commonReservation-utilities';

interface IProps extends StyledComponentProps {
    reservationRoom: reservationRoom;
    minStartTime: Date;
    maxEndTime: Date;
    minuteHeight: number;
    disabled: boolean;
    viewType: string;
    disabledChangeDay: boolean;
    nextDay: () => void;
    prevDay: () => void;
    showReservationSlotDetail: (reservationSlot: reservationSlot, reservationRoom: reservationRoom) => void;
}
const getDaySLots = (props: IProps) => {
    let reservationRoom = props.reservationRoom;
    let cloneStartDate = moment(props.minStartTime);
    let cloneEndDate = moment(props.maxEndTime);
    let cloneReservationRoomStartDate = getReservationMinStartDate(reservationRoom);
    let cloneReservationRoomEndDate = getReservationMaxEndtDate(reservationRoom);
    let slots: any[] = [];
    if (reservationRoom && reservationRoom.reservationSlots && reservationRoom.reservationSlots.length > 0) {
        let initalDiff = getMinutesOfDay(cloneReservationRoomStartDate) - getMinutesOfDay(cloneStartDate)
        if (initalDiff > 0) {
            slots.push(<ReservationSlot showReservationSlotDetail={(slot) => props.showReservationSlotDetail(slot, props.reservationRoom)}
                minuteHeight={props.minuteHeight} disabled={props.disabled} notAvailable reservationSlot={undefined} duration={initalDiff} classes={props.classes} />)
        }
        reservationRoom.reservationSlots.forEach(slot => {
            slots.push(<ReservationSlot showReservationSlotDetail={(slot) => props.showReservationSlotDetail(slot, props.reservationRoom)}
                minuteHeight={props.minuteHeight} disabled={props.disabled} reservationSlot={slot} classes={props.classes} />)
        })
        let endDiff = getMinutesOfDay(cloneEndDate) - getMinutesOfDay(cloneReservationRoomEndDate);
        if (endDiff > 0) {
            slots.push(<ReservationSlot showReservationSlotDetail={(slot) => props.showReservationSlotDetail(slot, props.reservationRoom)}
                minuteHeight={props.minuteHeight} disabled={props.disabled} notAvailable reservationSlot={undefined} duration={endDiff} classes={props.classes} />)
        }
    } else {
        slots.push(<ReservationSlot showReservationSlotDetail={(slot) => props.showReservationSlotDetail(slot, props.reservationRoom)}
            minuteHeight={props.minuteHeight} disabled={props.disabled} notAvailable reservationSlot={undefined} duration={getMinutesOfDay(cloneEndDate) - getMinutesOfDay(cloneStartDate)} classes={props.classes} />)
    }
    return slots;
}

const ReservationDay = (props: IProps) => {
    const classes = props.classes;
    // 
    return (
        <Grid key={"day-slot" + props.reservationRoom.dayCode} item className={classes.reservationDayColumn}>
            <ReservationColumnDayHeader classes={classes} {...props} />
            {getDaySLots(props)}
        </Grid>
    );

};
export default withStyles(styles as any)(ReservationDay)